import { render, staticRenderFns } from "./TableHeightButtons.vue?vue&type=template&id=af58a668&scoped=true&"
import script from "./TableHeightButtons.vue?vue&type=script&lang=js&"
export * from "./TableHeightButtons.vue?vue&type=script&lang=js&"
import style0 from "./TableHeightButtons.vue?vue&type=style&index=0&id=af58a668&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af58a668",
  null
  
)

export default component.exports